import React from "react";

import { useSelector } from "react-redux";

import { Dialog, DialogContent, DialogTitle } from "components/MaterialDialog";
import { RuleBookTable } from "components/RuleBookTable/index";

import { ModalTypes } from "constants/navigation";

import { getRuleBookById } from "selectors";

import { useModalAdapter } from "hooks";

const Modal = ({ onClose, ruleBookId }) => {
  const { name: title } = useSelector(getRuleBookById(ruleBookId));
  return (
    <>
      <Dialog open onClose={onClose} maxWidth="lg" fullWidth fullScreen>
        <DialogTitle onClose={onClose}>{title}</DialogTitle>
        <DialogContent dividers style={{ maxHeight: "85vh" }}>
          <RuleBookTable ruleBookId={ruleBookId} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export function RuleBookModalAdapter(props) {
  const [hashParams, _ignored, onClose] = useModalAdapter(
    ModalTypes.RuleBook,
    props,
  );

  const { id: ruleBookId } = hashParams;

  return <Modal ruleBookId={ruleBookId} onClose={onClose} />;
}
